import Navbar from "../Navbar/Navbar";
import SlidingHeader from "../SlidingHeader/SlidingHeader";
import Footer from "../Footer/Footer";
import BagContent from "./BagContent/BagContent";
import "./PageBag.scss";
function PageBag() {
  return (
    <>
      <SlidingHeader />
      <Navbar />
      <BagContent />
      <Footer />
    </>
  );
}

export default PageBag;
